<template>
	<div class="editor_content">
    <div class="editor">
			<!-- 富文本 -->
			<div class="editor_top">
        <y-quill-editor
          ref="myQuillEditor"
          v-model="content"
          height="122"
        />
			</div>
			<!-- 富文本 over -->
      <div class="editor_bottom">
				<div v-if="isRoomTeacher" v-show="quoteId === 0" class="encrypt_price">
        <!-- <div v-if="isRoomTeacher" v-show="$route.query.t === 'encrypted-view'" class="encrypt_price"> -->
	        <el-checkbox v-model="isEncryptedView">设置此条观点加密</el-checkbox>
          价格 ：
          <div class="price_wrap" v-for="item in priceitems" :key="item"  @click="price = item">{{item}}G币
            <div v-show="item == price">
              <span></span>
            </div>
          </div>
          其他：
          <input type="text" v-model.trim="price" /> 至少5G币，包月价格：<span>{{ encryptedViewMonthGolds > 0 ? encryptedViewMonthGolds : '暂无' }}</span> <span class="price_opa" @click="handleSet">设置</span>
        </div>
        <el-tag
					v-show="quoteId > 0"
          type="primary"
          :closable="true"
          @close="handleCancelQuote"
        >引用: {{ quoteUserName }}</el-tag>
      </div>

      <div class="encrypted-view-btn">
        <button type="button" @click="handleSubmit" :disabled="isSending">{{ isSending ? '发送中...' : '提交' }}</button>
      </div>
    </div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Dialog from '@/utils/Dialog'
import EditorMixin from '@/mixins/EditorMixin'

export default {
	name:'component-room-teacher-edit-view',
  mixins: [EditorMixin],
	data () {
		return {
			// 编辑器
      content: '',
      // 加密观点价格
      priceitems:[20, 50],
      // 单条价格
      price:20,

      // 付费观点
      isEncryptedView: false,

			// 是否发送中
      isSending: false
		}
  },
  methods: {
    handleSubmit (e) {
      const content = this.getContent()
      
       if (content.indexOf("base64")>0) {
            this.$notify({
              type: 'warning',
              message: '不能直接粘贴截图！',
              title: '警告'
            })
            return false
          }
      if (!content) return false

      if (this.isEncryptedView) {
        if (typeof this.price === 'string') {
          if (!/^[1-9]\d*$/.test(this.price)) {
            this.$notify({
              type: 'warning',
              message: '请输入数字！',
              title: '警告'
            })
            return false
          } else if (Number(this.price) < 5) {
            this.$notify({
              type: 'warning',
              message: '单条观点价格至少设置为5G币',
              title: '警告'
            })
            return false
          }
        }
        // 付费观点
        const params = {
          topic_id: this.roomData.lastTopicId,
          content,
          gcoins: this.price
        }
        // 禁用提交按钮
        this.isSending = true
        this.$axios._post('/EncryptedView/Add', params).then(resp => {
          if (this.$route.query.t !== 'encrypted-view') {
            this.isEncryptedView = false
          }
          this.setContent('')
          
          this.$axios._get('/EncryptedView/Detail', { id: resp.data.relationId }).then(res => {
            res.type = 10
            res.relationId = res.id
            res.data = res
            if (!this.$store.state.room.isWebsocket) {
              this.$store.commit('room/addMessage', res)
            }
            // this.$store.commit('room/addEncryptedViewList', res)
            this.isSending = false
          }).catch(err => {
            this.isSending = false
          })
        }).catch(error => {
	        this.isSending = false
        })
      } else {
        // 普通发言
        const params = {
          topic_id: this.roomData.lastTopicId,
          content,
          quote_index: this.quoteId,
        }
        // 禁用提交按钮
        this.isSending = true
        this.$axios._post('/Room/Message', params).then(res => {
          this.quoteId > 0 && this.handleCancelQuote()
          // 更新message
          if (!this.isWebsocket) {
            this.$store.commit('room/addMessage', res)
          }
          this.isSending = false
          this.setContent('')
        }).catch(error => {
          this.$alert('发言失败，请重试！')
					this.isSending = false
        })
      }
    },
    // 取消引用
    handleCancelQuote () {
      this.$store.commit('room/cancelQuote')
    },
    // 设置包月价格
    handleSet () {
      Dialog.prompt('请输入需要设置的包月价格（如果设置为 0，则取消包月功能）', '提示', {
        inputPattern: /[\d]+/,
        inputErrorMessage: '必须为数字',
      }).then(({ value }) => {
        let n = Number(value)
        if (n !== 0 && n < 167) {
          this.$notify({
            type: 'warning',
            title: '警告',
            message: '包月价格至少设置为168G币！'
          })
          return false
        }
        this.$axios._post('/Teacher/EncryptedViewMonthGold', { gcoins: n }).then(resp => {
          this.$store.commit('teacher/setEncryptedViewMonth', n)
          this.$notify.success({
            title: '成功',
            message: '修改付费观点包月价格成功'
          })
        })
      })
    }
  },
  computed: {
    ...mapState({
      roomData: state => state.room.data,
      quoteStatus: state => state.room.live.status,
      quoteId: state => state.room.live.quoteId,
      quoteUserName: state => state.room.live.quoteUserName,
      normalViewList: state => state.user.normalView,
      encryptedViewMonthGolds: state => state.teacher.data.encryptedViewMonth,
      isWebsocket: state => state.room.isWebsocket
    }),
    ...mapGetters({
      isRoomTeacher: 'room/isTeacher'
    })
  },
  watch: {
    quoteStatus () {
      this.setContent('')
      this.editor.focus()
    },
    '$route.query.t': {
      handler: function (newVal) {
        this.$parent.$parent.toBottom('live')
        this.isEncryptedView = this.$route.query.t === 'encrypted-view'
      },
      immediate: true
    } 
  }
}
</script>

<style lang="less" scoped>
.editor_content { height: 369px; padding: 16px 20px;
  .encrypted-view-btn { margin-top: 20px ; text-align: center;
    > button { width: 105px; line-height: 36px; border: none; background: #fb7a50; color: #FFFFFF; }
  }
  .editor_top { width: 100%; height: 162px; background: #FFFFFF; }
  .editor_bottom { margin-top: 16px;
    .encrypt_price { height: 40px; line-height: 40px; font-size: 13px;
      > label { padding-right: 20px;}
      > div { display: inline-block;  background: #FFFFFF; margin-right: 10px; width: 90px; font-weight: 700; text-align: center; font-size: 16px; position: relative; cursor: pointer;
        > div { width: 100%; height: 100%; position: absolute; left: 0; top: 0; border: 1px solid #7EBC59;
          > span {display: block; width: 20px; height: 20px; background: url(~assets/dagou.jpg) no-repeat; position: absolute; right: 0; bottom: 0;
          }
        }
      }
      > input { height: 40px; width: 46px; outline: none; border: none; font-size: 16px; padding-left: 2px;}
      > .price_opa { color: #f60305; margin-left: 10px; cursor: pointer; }
    }
  }
}
</style>
